export enum DialogsEnums {
  Alert, Confirm, Prompt
}
